var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('v-img',{attrs:{"id":"banner-desktop","src":require("@/assets/banner_desktop.png")}}),_c('v-img',{attrs:{"id":"banner-mobile","src":require("@/assets/banner_mobile.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }